import { isIOS } from "../support/isIos";

export default (tableName = 'orders') => ({
    init() {
        window.addEventListener('orders::edit::blank', ({ detail }) => {
            const target = isIOS() ? '_self' : '_blank';
            window.open(detail.route, target);
        });

        this.onVisibilityChange = () => {
            if (document.visibilityState !== 'visible') {
                return;
            }

            Livewire.dispatch(`refresh-table:${tableName}`);
        };

        document.addEventListener('visibilitychange', this.onVisibilityChange);
    },

    destroy() {
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
});
